// External Dependencies
import React from 'react';
import injectTapEventPlugin from 'react-tap-event-plugin';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import Perf from 'react-addons-perf';
import { Provider } from 'react-redux';
import { Router, useRouterHistory } from 'react-router';
import { createHashHistory } from 'react-router/node_modules/history';

// Internal Dependencies
import initializeStore from './state';
import { routes } from './routes';

window.Perf = Perf;

// Needed for onTouchTap event handling
injectTapEventPlugin();

// Create the redux store
const store = initializeStore();

// Render redux dev tools if on development
const reduxDevTools = process.env.NODE_ENV === 'development'
  ? React.createElement(require('./redux-dev-tools').default)
  : null;

const rootStyles = { height: '100%' };

// Create the browser history
const appHistory = useRouterHistory(createHashHistory)({ queryKey: false });

// Component definition
const App = () => (
  <Provider store={store}>
    <MuiThemeProvider>
      <div style={rootStyles}>
        <Router
          history={appHistory}
          routes={routes}
        />
        {reduxDevTools}
      </div>
    </MuiThemeProvider>
  </Provider>
);

export default App;



/** WEBPACK FOOTER **
 ** ./src/App.js
 **/